;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.RegistrationFormBuild = Model.RegistrationFormBuild.extend({
		defaults: {
			steps_chain: ['registrationStep1','registrationStep2'],
			steps_layouts: {
				first_step:  'RightSidebar',
				second_step: 'RightSidebar',
				register_for_game:  'RightSidebar',
				register_recover: 'RightSidebar',
				join_create_league: ''
			},
			steps_views: {
				first_step:  'ClubsIonataRegistrationStep1',
				second_step: 'ClubsIonataRegistrationStep2',
				register_for_game:  'RegisterForGame',
				join_create_league: '',
				register_recover: 'ClubsRegisterRecover',

			},
			register_recover_fields: 'terms',
			first_step_url: 'registration/step_1',
			first_step_fields: 'first_name,last_name,email,confirm_email,password,passwordConfirm',
			first_step_head_fields:'jmc_hear_about',
			second_step_fields: 'avatar,team_name,team_supported,country,state,mobile,birthday,gender,terms',
			first_step_BE_check: ['checkEmail'],
			second_step_BE_check: ['checkTeamName'],
			first_step_buttons: [
				{ text: "Continue &rsaquo;", id: "js-submit-step"}
			],
			second_step_buttons: [
				{text: "Register &rsaquo;", id: "js-submit-step"},
				{text: "&lsaquo; Back", id: "js-return-step"}
			],
			games_supported: ["afl_tipping"],
			game_spec_fields: 'team_supported,news',
			step1_side_bar_widgets: ['Promo', 'Steps' , 'Promo'],
			step2_side_bar_widgets: ['Promo', 'Steps' , 'Promo'],
			league_model: '',
			league_collection: ''
		}
	});

}(window, APP, Backbone, Marionette, $, _));